module.exports = __webpack_public_path__ + "media/light.92f5cf93.webm";